import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Tab, TabPanel, Tabs, TabsList } from 'base-ui'

import erxImage from '../../../../public/images/illustrations/illustration-erx-m-dark.png'
import { StaticImage } from '../../../image'
import { useProductPageOdsContext } from '../../ods/components/productPageODSContext'
import { useProductPageContext } from '../productPageContext'

import { ProductPageOdsDialogButtonsGroup } from './ProductPageOdsDialogButtonsGroup'
import { ProductPageOdsDialogFeatureDescription } from './ProductPageOdsDialogFeatureDescription'
import { ProductPageOdsDialogLocalDoctorTabsPanel } from './ProductPageOdsDialogLocalDoctorTabsPanel'
import { ProductPageOdsDialogOnlineDoctorTabsPanel } from './ProductPageOdsDialogOnlineDoctorTabsPanel'

export const ProductPageOdsDialogContent: FC = () => {
  const { experimentOdsV1Enabled, videoConsultation } =
    useProductPageOdsContext()
  const { productPageOdsConfig } = useProductPageContext()

  const intl = useIntl()

  const isVideoConsultationAndExperimentOdsV1Enabled =
    videoConsultation && experimentOdsV1Enabled

  return (
    <>
      <div className="flex flex-col items-start tablet:flex-row">
        <StaticImage
          alt={intl.formatMessage({
            id: 'pdp.buyboxwithvariants.odsModal.image.alt',
          })}
          className="mx-auto mb-8 shrink-0"
          height={144}
          src={erxImage}
          width={162}
        />
        <div className="tablet:pl-3.5">
          <h2 className="text-xl">
            {isVideoConsultationAndExperimentOdsV1Enabled ? (
              <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.header" />
            ) : (
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.header" />
            )}
          </h2>

          <ProductPageOdsDialogFeatureDescription
            isVideoConsultationAndExperimentOdsV1Enabled={
              isVideoConsultationAndExperimentOdsV1Enabled
            }
          />

          <ProductPageOdsDialogButtonsGroup
            onlineDoctorServiceLink={
              (isVideoConsultationAndExperimentOdsV1Enabled
                ? productPageOdsConfig?.videoConsultationLink
                : productPageOdsConfig?.odsLandingPageForProduct) ?? undefined
            }
          />
        </div>
      </div>

      <div className="mt-10">
        <Tabs defaultValue={0}>
          <TabsList>
            <Tab>
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.title" />
            </Tab>
            <Tab>
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab2.title" />
            </Tab>
          </TabsList>
          <TabPanel>
            <ProductPageOdsDialogOnlineDoctorTabsPanel />
          </TabPanel>
          <TabPanel>
            <ProductPageOdsDialogLocalDoctorTabsPanel />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}
